// Copyright (c) 2026 Solartek LLC. All rights reserved.

import type { RouteObject } from 'react-router';
import { employeesRoutes } from './employees/routes';
import { organizationRoutes } from './organization/routes';
import { usersRoutes } from './users/routes';
import { settingsRoutes } from './settings/routes';
import { auditRoutes } from './audit/routes';
import { searchRoutes } from './search/routes';
import { devicesRoutes } from './devices/routes';
import { syncRoutes } from './sync/routes';
import { attendanceRoutes } from './attendance/routes';
import { correctionsRoutes } from './corrections/routes';
import { approvalsRoutes } from './approvals/routes';
import { scheduleRoutes } from './schedule/routes';
import { reportsRoutes } from './reports/routes';
import { payrollRoutes } from './payroll/routes';
import { leaveRoutes } from './leave/routes';
import { portalRoutes } from './portal/routes';
import { teamRoutes } from './team/routes';
import { attendanceReviewRoutes } from './attendance-review/routes';
import { attendanceAdminRoutes } from './attendance-admin/routes';
import { policiesRoutes } from './policies/routes';
import { schedulingRoutes } from './scheduling/routes';
// attendance watchlist and observations (workforce controls §6)
import { watchlistRoutes } from './watchlist/routes';
// meetings: rooms, attendance, analytics (workforce controls §7)
import { meetingsRoutes } from './meetings/routes';
// Flowza Surveillance: the Productivity dashboard and the employee drill-down (the portal's /my/productivity is a portal route)
import { productivityRoutes } from './productivity/routes';

/** Every feature exports its RouteObject[] from features/<name>/routes.tsx (lazy pages). */
export const featureRoutes: RouteObject[] = [
  ...employeesRoutes, ...organizationRoutes, ...usersRoutes, ...settingsRoutes, ...auditRoutes, ...searchRoutes,
  ...devicesRoutes, ...syncRoutes, ...attendanceRoutes, ...correctionsRoutes, ...approvalsRoutes, ...scheduleRoutes,
  ...reportsRoutes, ...payrollRoutes, ...leaveRoutes, ...portalRoutes, ...teamRoutes,
  ...attendanceReviewRoutes,
  ...attendanceAdminRoutes,
  ...policiesRoutes,
  // Enterprise round-the-clock scheduling (module advanced_scheduling): /deployments, /attendance/muster
  ...schedulingRoutes,
  // attendance watchlist and observations (workforce controls §6): /watchlist
  ...watchlistRoutes,
  // meetings (workforce controls §7): /meetings, /meetings/:id (the portal's /my/meetings is a portal route)
  ...meetingsRoutes,
  // Flowza Surveillance (docs/integrations/flowza-surveillance.md): /productivity, /productivity/employees/:employeeId
  ...productivityRoutes,
];
